export default __webpack_public_path__ + "static/media/inventory_policy.7df8eee9.pdf";